import React from "react";
import ModalFormMovimiento from "./ModalFormMovimiento";

const ModalMovimiento = ({ show, handleClose, movimiento }) => {
  return (
    <ModalFormMovimiento show={show} handleClose={handleClose} movimiento={movimiento} />
  );
};

export default ModalMovimiento;

